export const TIPO_NOTA = {
  secao: {
    codigo: 1,
    descricao: "SECAO",
    sigla: "NS" /*Nota de Seção*/,
  },
  capitulo: {
    codigo: 2,
    descricao: "Capítulo",
    sigla: "NC" /*Nota de Capítulo*/,
  },
  posicao: {
    codigo: 3,
    descricao: "Posição",
    sigla: "PS" /*Nota de Capítulo*/,
  },
  subcapitulo: {
    codigo: 4,
    descricao: "SubCapítulo",
    sigla: "SC" /*Nota de Capítulo*/,
  },
  rgi: {
    codigo: 5,
    descricao: "RGI",
    sigla: "RGI" /*Nota de Capítulo*/,
  },
  anexo: {
    codigo: 6,
    descricao: "Anexo",
    sigla: "AN" /*Nota de Capítulo*/,
  },
};

export const MSG_NESH_NAO_ENCONTRADA: string =
  "O código pesquisado não existe na data de referência. ";
